import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type ConvertDetailsForm = {
  fromWallet: string
  toWallet: string
  fromAmount: string
  toAmount: string
  reference: string
}

export interface ConvertDetailsFormData extends ConvertDetailsForm {
  changedField: string
}

export type ConvertDetailsFormKeys = keyof ConvertDetailsForm

export const convertDetailsSchema = (t: TFunction<'translation', string>) => {
  const { getYupField, getRequiredYupField } = useYupFields()

  return yup.object<Record<ConvertDetailsFormKeys, yup.StringSchema>>({
    fromWallet: getRequiredYupField({
      label: t('wallets.convert.convertFundsFrom'),
      requiredErrorMessage: t('wallets.convert.convertFromWalletRequired'),
    }),
    toWallet: getRequiredYupField({
      label: t('wallets.convert.receiveFundsTo'),
      requiredErrorMessage: t('wallets.convert.convertToWalletRequired'),
    }),
    fromAmount: getYupField({
      label: t('wallets.convert.amountToConvert'),
    }),
    toAmount: getYupField({
      label: t('wallets.convert.amountToReceive'),
    }),
    reference: getYupField({
      label: t('formFields.uniqueReference'),
    }),
  })
}
